<template>
	<b-modal
		:visible="show"
		:ok-disabled="loadingSubmit"
		:cancel-disabled="loadingSubmit"
		@cancel="close"
		@ok="submit"
		@hide="close"
		:ok-title="'modalAddNotification.submit' | translate"
		:cancel-title="'modalAddNotification.cancel' | translate"
		:title="'modalAddNotification.title' | translate"
	>
		<div v-if="loading" class="loader"><loader /></div>
		<form v-else @submit.prevent="submit" class="modal-block">
			<vue-editor
				:id="`editor-notification`"
				:editorToolbar="toolbar"
				v-model="text"
			/>
			<p v-if="error" class="text-danger">{{ error }}</p>
		</form>
	</b-modal>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import Loader from '@/components/Loader'
export default {
	components: { VueEditor, Loader },
	name: 'modal-add-notification',
	data: () => ({
		text: '',
		loadingSubmit: false,
		loading: false,
		error: '',
	}),
	props: ['show', 'groupId'],
	watch: {
		groupId() {
			if (this.groupId) {
				this.requestProfileData()
			}
		},
		show() {
			this.text = ''
			this.error = ''
			this.loadingSubmit = false
			this.loading = false
		},
	},
	created() {
		if (this.groupId) {
			this.requestProfileData()
		}
	},
	computed: {
		toolbar: () => [['bold', 'italic', 'underline', 'link'], ['image']],
	},
	methods: {
		submit(e) {
			if (e) e.preventDefault()
			this.loadingSubmit = true
			this.axios({
				url: `groups/${this.groupId}/notification`,
				method: 'post',
				data: {
					notification: this.text,
				},
			})
				.then(({ data }) => {
					this.loadingSubmit = false
					this.close()
				})
				.catch(error => {
					const response = error.response.data.detail
					this.loadingSubmit = false

					if (response && response.non_field_errors) {
						this.error = response.non_field_errors.join('\n')
					} else {
						this.error = 'Error has occurred'
					}
				})
		},
		close() {
			this.$emit('close')
		},

		requestProfileData() {
			this.loading = true
			this.axios({
				method: 'get',
				url: `groups/${this.groupId}`,
			})
				.then(({ data }) => {
					this.text = data.notification || ''
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button:not(.close) {
	margin: 10px;
}

.loader svg {
	display: block;
	margin: auto;
	width: 100px;
	height: 100px;
}
</style>
